import { render, staticRenderFns } from "./cfsBatchUpdateMAWB.vue?vue&type=template&id=5957792c&"
import script from "./cfsBatchUpdateMAWB.vue?vue&type=script&lang=js&"
export * from "./cfsBatchUpdateMAWB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports